import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { LocationComponentService } from 'src/app/services/locationComponent/location-component.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';
import { GenericTypeStoreService } from 'src/app/stores/generic-types-store/generic-type-store.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.sass'],
})
export class CreateComponent implements OnInit, OnDestroy {
  id;
  form: FormGroup;
  componentTypeList;
  dataServiceSub: Subscription;
  locationCompServiceSub: Subscription;

  constructor(
    private router: Router,
    private locationCompService: LocationComponentService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private _t: TranslateService,
    private locationStore: LocationStoreService,
    private genericTypeStore: GenericTypeStoreService
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      location: ['', Validators.required],
      component_type: ['', Validators.required],
      name: ['', Validators.required],
    });
    this.componentTypeList = this.genericTypeStore.getGenericType('component')
    this.dataServiceSub = this.locationStore.currLocation$.subscribe((res) => {
      if (res.id) {
        this.id = res.id;
        this.form.patchValue({ location: this.id });
      }
    });
  }

  onCreate() {
    this.spinner.show();
    this.locationCompServiceSub = this.locationCompService.create(this.form.value).subscribe((res) => {
      this.spinner.hide();
      this.router.navigate(['/projects', this.id, 'details', 'info']);
    }, ({error}) => {
      this.spinner.hide();
      const msg = error.message.reduce((results, u) => (results += u + ', ', results), '').slice(0, -2)
      this.toastr.error(this._t.instant(msg), this._t.instant('Error'));
    });
  }

  ngOnDestroy() {
    this.dataServiceSub.unsubscribe()
    if (this.locationCompServiceSub) this.locationCompServiceSub.unsubscribe()
  }
}
